import { createSelector } from 'reselect'
import select from '@signal/utils/select'
import { stateSelector } from '@signal/core/router/selectors'
import { SHOW_ALL } from '../../core/channels/constants'

export const initialSelectedGroupSelector = createSelector(
  stateSelector,
  select('selectedGroup', SHOW_ALL)
)
